// Mock data for Siyarasoi Foundation Landing Page

export const impactStats = [
  {
    id: 1,
    number: "50,000+",
    label: "Meals Served",
    icon: "utensils"
  },
  {
    id: 2,
    number: "2,000+",
    label: "People Fed Daily",
    icon: "users"
  },
  {
    id: 3,
    number: "15+",
    label: "Distribution Points",
    icon: "map-pin"
  },
  {
    id: 4,
    number: "100%",
    label: "Free For Everyone",
    icon: "heart"
  }
];

export const howToHelpOptions = [
  {
    id: 1,
    title: "Donate",
    description: "Your contribution helps us provide nutritious meals to those in need. Every donation makes a difference.",
    icon: "hand-heart",
    action: "Make a Donation"
  },
  {
    id: 2,
    title: "Volunteer",
    description: "Join our team of dedicated volunteers and be part of the change. Help us serve meals and spread joy.",
    icon: "users",
    action: "Become a Volunteer"
  }
];

export const missionPoints = [
  {
    id: 1,
    title: "No One Goes Hungry",
    description: "We believe access to nutritious food is a basic human right. Our mission is to ensure no one sleeps hungry in Ayodhya region.",
    icon: "heart-handshake"
  },
  {
    id: 2,
    title: "Dignity & Respect",
    description: "Every meal is served with love, compassion, and respect. We treat every individual with the dignity they deserve.",
    icon: "smile"
  },
  {
    id: 3,
    title: "Community Driven",
    description: "Built on the power of community support, we bring together volunteers, donors, and partners to create lasting impact.",
    icon: "users-round"
  }
];

export const contactFormSubmit = async (formData) => {
  // Mock submission - will be replaced with actual API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({ success: true, message: "Thank you for reaching out! We'll get back to you soon." });
    }, 1000);
  });
};
